import React from 'react'
import { Link } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'
import { Button } from './ui/button'

const Hero: React.FC = () => {

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-50 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-gray-100 opacity-25" />
      
      <div className="relative container mx-auto px-4 py-16 lg:py-24">
        <div className="text-center max-w-4xl mx-auto">
          {/* Trust Badge */}
          <div className="inline-flex items-center rounded-full border border-gray-200 bg-white/80 px-4 py-2 text-sm text-gray-600 mb-6">
            <TrendingUp className="h-4 w-4 mr-2 text-excel-green" />
            Trusted by 10,000+ Excel Professionals
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
            Master Excel Like a{' '}
            <span className="bg-gradient-to-r from-excel-green to-excel-blue bg-clip-text text-transparent">
              Pro
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Learn advanced Excel techniques, shortcuts, and formulas from industry experts. 
            Transform your spreadsheet skills and boost your productivity.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/blog">
              <Button variant="excel" size="lg" className="text-lg px-8 py-6">
                Start Learning Now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
